import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import collabImage from "../assets/collab.png";
import "../styles/collaboration.css";

export default function Collaboration() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("collaboration", lang).then(data => setContent(data));
  }, [lang]);

  const text = [
    content.collab,
    content.collab_1,
    content.collab_2,
    content.collab_3,
    content.collab_4,
    content.collab_5,
    content.collab_6,
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;
  return (
  <section className="collaboration-page">
     <div className="collaboration-header">
  <h1 className="collaboration-title">
    {content.collab_title}
  </h1>

  <h2 className="collaboration-subtitle">
    {content.collab_subtitle}
  </h2>

  <p className="collaboration-intro">
    {content.collab_intro}
  </p>
</div>

<div className="section-divider"></div>

  <div className="collaboration-content">

  <div className="collaboration-image">
    <img
      src={collabImage}
      alt="Shipbuilding cooperation"
    />
  </div>

  <div className="collaboration-list-section">

    <h2 className="collaboration-list-title">
      {content.collab_title_1}
    </h2>

    <div className="collaboration-content-list">
      {text.map((item, idx) => (
        <div
          key={idx}
          className="collaboration-content-item"
        >
          ✔ {item}
        </div>
      ))}
    </div>

  </div>

</div>

<div className="section-divider"></div>

{/* List  */}
<div className="intro-row">

<div className="intro-item">
    <p>{content.collab_text_1}</p>
  </div>

 <div className="intro-item">
    <p>{content.collab_text_2}</p>
  </div>

  <div className="intro-item">
    <p>{content.collab_text_3}</p>
  </div>

  <div className="intro-item">
    <p>{content.collab_text_4}</p>
  </div>

  <div className="intro-item">
    <p>{content.collab_text_5}</p>
  </div>

</div>
  
<div className="section-divider"></div>

      <div className="collaboration-bottom">
    <p>{content.collab_text_6}</p>
    </div>

      <div className="spacer"/>
    </section>

  );

};